import styled from "styled-components";
import { device } from "../breakpoints";

export const OurJourneySection = styled.section`
  background: #000
    url("https://tripmoneycmsimgak.mmtcdn.com/img/grid_dc77da6617.svg") 0 0
    repeat;
  height: 100vh;
  position: relative;
  padding: 100px 0;
  overflow: hidden;
  margin: 0 auto;
  @media ${device.mobile} {
    padding: 40px 0;
    height: auto;
  }
`;
export const OurJourneyInner = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  padding: 100px 0;
  z-index: 2;
  @media ${device.mobile} {
    padding: 40px 0;
    position: unset;
  }
`;
export const OurJourneyArrow = styled.img`
  width: 75%;
  position: absolute;
  left: 0;
  top: 100px;
  z-index: 1;
`;
export const OurJourneyWrapper = styled.div`
  width: 1200px;
  margin: 0 auto;
  > h2 {
    font-family: "Raleway";
    font-size: 48px;
    line-height: 64px;
    color: #fff;
    font-weight: 400;
    @media ${device.mobile} {
      font-size: 32px;
      line-height: 36px;
    }
  }
  > h3 {
    max-width: 810px;
    font-family: "Open Sans";
    font-size: 22px;
    line-height: 30px;
    font-weight: 400;
    color: #afafaf;
    margin-top: 16px;
    @media ${device.mobile} {
      max-width: 100%;
      font-size: 16px;
      line-height: 22px;
    }
  }
  @media ${device.mobile} {
    width: 100%;
    padding: 0 16px;
  }
`;
export const OurJourneyCardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  @media ${device.mobile} {
    flex-direction: column-reverse;
    align-items: flex-start;
  }
`;
